const OPEN_URL = 'open_url';
const DOWNLOAD_FILE = 'download_file';
const RUN_FEATURE_AGAIN = 'run_feature_again';
// const  close_tab_or_modal  =   'run_a_different_feature'
// const close_tab_or_modal   = 'close_tab_or_modal'
const CLOSE_MODAL = 'close_modal';
const COPY_TO_CLIPBOARD = 'copy_to_clipboard';

export const ACTION_TYPES = {
	OPEN_URL,
	DOWNLOAD_FILE,
	RUN_FEATURE_AGAIN,
	CLOSE_MODAL,
	COPY_TO_CLIPBOARD,
};

export const FLOW_RUNNER_END_RUN_ACTION_TYPES = {
	DISPLAY_INTERFACE: 'display-interface',
	DISPLAY_MESSAGE: 'display-message',
	CLOSE_TAB: 'close-tab',
	OPEN_URL: 'open-url',
	NO_ACTION: 'NO_ACTION',
};

export const END_RUN_ACTION_TYPES = {
	DISPLAY_INTERFACE: 'display_interface',
	DISPLAY_MESSAGE: 'display_message',
	CLOSE_TAB: 'close_tab',
	OPEN_URL: 'open_url',
	NO_ACTION: 'NO_ACTION',
};

export const OPEN_URL_OPTIONS = {
	OPEN_IN_NEW_TAB: 'OPEN_IN_NEW_TAB',
	OPEN_IN_SAME_TAB: 'OPEN_IN_SAME_TAB',
};

export const BUTTONS_STYLES = {
	PRIMARY: 'PRIMARY',
	SECONDARY: 'SECONDARY',
};
